export default __webpack_public_path__ + "static/media/Kor-logo.b920be50.svg";